import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import {
  AsignacionCursoExterno,
  AsignarCursoExternoDto,
  CompletarCursoExternoDto,
  CompletitudCursoExterno,
  CompletitudesExternoResponse,
  CreateCursoExternoDto,
  CursoExterno,
  UpdateCursoExternoDto,
} from './types/cursosExternos.types';

export class CursosExternosService {
  static async create(dto: CreateCursoExternoDto): Promise<CursoExterno> {
    const response: AxiosResponse<CursoExterno> = await AxiosService.post('/cursos-externos', dto);
    return response.data;
  }

  static async findAll(): Promise<CursoExterno[]> {
    const response: AxiosResponse<CursoExterno[]> = await AxiosService.get('/cursos-externos');
    return response.data;
  }

  static async misCursosExternos(): Promise<CursoExterno[]> {
    const response: AxiosResponse<CursoExterno[]> = await AxiosService.get('/cursos-externos/mis-cursos-externos');
    return response.data;
  }

  static async findOne(id: string): Promise<CursoExterno> {
    const response: AxiosResponse<CursoExterno> = await AxiosService.get(`/cursos-externos/${id}`);
    return response.data;
  }

  static async update(id: string, dto: UpdateCursoExternoDto): Promise<CursoExterno> {
    const response: AxiosResponse<CursoExterno> = await AxiosService.patch(`/cursos-externos/${id}`, dto);
    return response.data;
  }

  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/cursos-externos/${id}`);
  }

  static async asignar(cursoExternoId: string, dto: AsignarCursoExternoDto): Promise<AsignacionCursoExterno> {
    const response: AxiosResponse<AsignacionCursoExterno> = await AxiosService.post(
      `/cursos-externos/${cursoExternoId}/asignaciones`,
      dto,
    );
    return response.data;
  }

  static async listAsignaciones(cursoExternoId: string): Promise<AsignacionCursoExterno[]> {
    const response: AxiosResponse<AsignacionCursoExterno[]> = await AxiosService.get(
      `/cursos-externos/${cursoExternoId}/asignaciones`,
    );
    return response.data;
  }

  static async removeAsignacion(asignacionId: string): Promise<void> {
    await AxiosService.delete(`/cursos-externos/asignaciones/${asignacionId}`);
  }

  static async completar(cursoExternoId: string, dto: CompletarCursoExternoDto): Promise<CompletitudCursoExterno> {
    const response: AxiosResponse<CompletitudCursoExterno> = await AxiosService.post(
      `/cursos-externos/${cursoExternoId}/completar`,
      dto,
    );
    return response.data;
  }

  static async getProgreso(cursoExternoId: string): Promise<CompletitudCursoExterno | null> {
    const response: AxiosResponse<CompletitudCursoExterno | null> = await AxiosService.get(
      `/cursos-externos/${cursoExternoId}/progreso`,
    );
    return response.data;
  }

  static async getCompletitudes(cursoExternoId: string): Promise<CompletitudesExternoResponse> {
    const response: AxiosResponse<CompletitudesExternoResponse> = await AxiosService.get(
      `/cursos-externos/${cursoExternoId}/completitudes`,
    );
    return response.data;
  }
}
